import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { INITIAL_BUSINESS_PUBLIC_ID } from '~/domains/mmp/constants';
import { STORAGE_KEYS } from '~/utils/storage';

interface State {
  businessId: string;
  setBusinessId: (businessId: string) => void;
}

export const useBusinessIdStore = create(
  persist<State>(
    (set) => ({
      businessId: INITIAL_BUSINESS_PUBLIC_ID,
      setBusinessId: (businessId: string) => {
        set({ businessId });
      },
    }),
    {
      name: STORAGE_KEYS.BUSINESS_ID,
    },
  ),
);
